import classNames from 'classnames';
import * as React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
    as?: 'div' | 'section';
    muted?: boolean;
}

export const Card: React.FunctionComponent<CardProps> = ({as: As = 'div', muted, className, children, ...rest}: CardProps) => (
    <As className={classNames('mp-card', {'mp-card--muted': muted}, className)} {...rest}>
        {children}
    </As>
);
